import { c as _c } from "react/compiler-runtime";
import { Typography } from '@mui/material';
type Props = {
  color?: string;
  children: string;
};
export function SectionTitle(t0) {
  const $ = _c(6);
  const {
    color: t1,
    children
  } = t0;
  const color = t1 === undefined ? "black" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      xs: 24,
      md: 30
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== color) {
    t3 = {
      fontSize: t2,
      fontWeight: 700,
      lineHeight: 1.3,
      letterSpacing: "0.15px",
      textAlign: "center",
      color
    };
    $[1] = color;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== t3) {
    t4 = <Typography component="h2" sx={t3}>{children}</Typography>;
    $[3] = children;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}